import "../Button/Button.css";

// Imports from Material UI
import { Button, Typography } from "@mui/material";
import { ReactElement } from "react";

type LinkStyledButtonProps = Readonly<{
	text?: string | ReactElement;
	style?: string;
	startIcon?: ReactElement;
	endIcon?: ReactElement;
	disabled?: boolean;
	onClick?: () => void;
}>;
export default function LinkStyledButton(props: LinkStyledButtonProps) {
	const { text = "", style = "", startIcon, endIcon, disabled = false, onClick = () => {} } = props;
	return (
		<Button
			startIcon={startIcon}
			endIcon={endIcon}
			disabled={disabled}
			onClick={onClick}
			sx={{ padding: 0, color: "#2357BE !important" }}
		>
			<Typography
				sx={{
					boxShadow: "none",
					color: style !== "regular" ? "#2357BE" : "#666666",
					textTransform: "capitalize",
					fontFamily: "PTSansProNarrow",
					fontSize: "14.5px",
					backgroundColor: "transparent",
				}}
			>
				{text}
			</Typography>
		</Button>
	);
}
